module.exports = __webpack_public_path__ + "static/img/6.fb0b141.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/sp/6.png
// module id = Po4+
// module chunks = 0